import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import {
  CHANGE_SEARCH_INPUT,
  CHANGE_WITHIN_LAST_DAYS,
  CREATE_IP_RANGE_ASYNC,
  DELETE_IP_RANGE_ASYNC,
  GET_IP_RANGE_LIST_ASYNC,
  UPDATE_IP_RANGE_ASYNC,
} from './constants'
import { selectIpModalData, selectIpRangeListData } from './selectors'

const getIpRangeListEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(GET_IP_RANGE_LIST_ASYNC.INITIATE, CHANGE_SEARCH_INPUT, CHANGE_WITHIN_LAST_DAYS)
    .switchMap(() =>
      api.settings
        .getIpRangeList(
          store.getState().partnerOptions.selectedCompany?.value,
          selectIpRangeListData(store.getState()).search,
          selectIpRangeListData(store.getState()).withinLastDays
        )
        .map((response) => GET_IP_RANGE_LIST_ASYNC.onSuccess({ data: response }))
        .catch((error) => Observable.of(epicsErrorHandler(GET_IP_RANGE_LIST_ASYNC.onError, error)))
        .takeUntil(action$.ofType(GET_IP_RANGE_LIST_ASYNC.CANCEL))
    )

const createIpRangeEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(CREATE_IP_RANGE_ASYNC.INITIATE).switchMap(() => {
    const ipDataModel = selectIpModalData(store.getState())

    return api.settings
      .createIpRange(store.getState().partnerOptions.selectedCompany?.value, {
        name: ipDataModel.name,
        rawValues: ipDataModel.rawValues,
        description: ipDataModel.description,
        applyForPastCampaigns: ipDataModel.isApplyForPastCampaigns,
      })
      .map((response) => CREATE_IP_RANGE_ASYNC.onSuccess({ data: response }))
      .catch((error) => Observable.of(epicsErrorHandler(CREATE_IP_RANGE_ASYNC.onError, error, 400)))
      .takeUntil(action$.ofType(CREATE_IP_RANGE_ASYNC.CANCEL))
  })

const updateIpRangeEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(UPDATE_IP_RANGE_ASYNC.INITIATE).switchMap(() => {
    const apiData = selectIpModalData(store.getState())

    return api.settings
      .updateIpRange(store.getState().partnerOptions.selectedCompany?.value, apiData.id, {
        name: apiData.name,
        rawValues: apiData.rawValues,
        description: apiData.description,
        applyForPastCampaigns: apiData.isApplyForPastCampaigns,
      })
      .map((response) => UPDATE_IP_RANGE_ASYNC.onSuccess({ data: response }))
      .catch((error) => Observable.of(epicsErrorHandler(UPDATE_IP_RANGE_ASYNC.onError, error, 400)))
      .takeUntil(action$.ofType(UPDATE_IP_RANGE_ASYNC.CANCEL))
  })

const deleteIpRangeEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(DELETE_IP_RANGE_ASYNC.INITIATE)
    .switchMap(() => {
      const apiData = selectIpModalData(store.getState())
      const ids = apiData.id ? [apiData.id] : selectIpRangeListData(store.getState()).selectedItems

      return api.settings.deleteIpRange(store.getState().partnerOptions.selectedCompany?.value, ids)
    })
    .map((response) => DELETE_IP_RANGE_ASYNC.onSuccess({ data: response }))
    .catch((error) => Observable.of(epicsErrorHandler(DELETE_IP_RANGE_ASYNC.onError, error, 400)))
    .takeUntil(action$.ofType(DELETE_IP_RANGE_ASYNC.CANCEL))

export default combineEpics(
  getIpRangeListEpic,
  createIpRangeEpic,
  updateIpRangeEpic,
  deleteIpRangeEpic
)
